// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"390":"fef8940d","615":"f4663b20","680":"d307abad"}[chunkId] + ".css";
};